import Grid from '@mui/material/Grid'
import React, { useEffect } from 'react'
import { languages } from '../constant'
import { FormTextField } from './FormCore'

interface LanguageSpecificTextFieldProps {
  data?: any
  label?: string
  form: any
  disabled?: boolean
  stacked?: boolean
}

export const LanguageSpecificTextField: React.FC<LanguageSpecificTextFieldProps> = ({
  data,
  label,
  form,
  disabled = false,
  stacked = false,
}) => {
  useEffect(() => {
    if (!data) return
    const outputJson = typeof data === 'string' ? JSON.parse(data) : data
    languages.forEach(lang => {
      form.setValue(`label_${lang}`, outputJson[lang])
    })
  }, [data, form])

  return (
    <Grid container>
      {languages.map(language => {
        return (
          <Grid key={language} item xs={stacked ? 12 : 6}>
            <FormTextField
              className="w-full"
              name={`label_${language}`}
              label={`${label}-${language}`}
              disabled={disabled}
            />
          </Grid>
        )
      })}
    </Grid>
  )
}
